import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

class BancoSatService {
	static Listar = (filtro, paginacion) => {
		let params = {
			filtro: {
				clave: filtro.clave || null,
				banco: filtro.banco || null,
				razon_social: filtro.razon_social || null,
				activo: (Number(filtro.activo) === 1 || Number(filtro.activo) === 0) ? Number(filtro.activo) : 'all',
			},
			paginacion: {
				total: paginacion.total || null,
				page: paginacion.page || null,
				limit: paginacion.limit || null
			}
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Banco_Sat_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	};
	static Agregar = (form) => {
		let params = {
			id_cat_banco_sat: null,
			clave: form.clave,
			nombre_razon_social: form.nombre_razon_social,
			descripcion: form.descripcion,
			logo_archivo: form.logo_archivo,
			logo_formato: form.logo_formato,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Banco_Sat_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	};
	static Modificar = (form) => {
		let params = {
			id_cat_banco_sat: form.id_cat_banco_sat,
			clave: form.clave,
			nombre_razon_social: form.nombre_razon_social,
			descripcion: form.descripcion,
			logo_archivo: form.logo_archivo,
			logo_formato: form.logo_formato,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Banco_Sat_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	};
	static Eliminar = (id_cat_banco_sat) => {
		let params = {
			id_cat_banco_sat: id_cat_banco_sat
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Banco_Sat_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	};
}

export default BancoSatService;
